"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
var await_lock_1 = __importDefault(require("await-lock"));
var utils_1 = require("ethers/utils");
var ethUtil = __importStar(require("ethereumjs-util"));
var Dcent = (function (_super) {
    __extends(Dcent, _super);
    function Dcent(dcent) {
        var _this = _super.call(this) || this;
        _this.awaitLock = new await_lock_1.default();
        _this.PATH = "m/44'/60'/0'/0/0";
        _this.dcent = dcent;
        return _this;
    }
    Dcent.prototype.reconnect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.disconnect()];
                    case 1:
                        _a.sent();
                        return [4, new Promise(function (resolve, reject) {
                                setTimeout(function () {
                                    _this.connect();
                                    resolve();
                                }, 100);
                            })];
                    case 2:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    Dcent.prototype.connect = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.dcent.dcentPopupWindow()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    Dcent.prototype.disconnect = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.dcent.popupWindowClose()];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    Dcent.prototype.type = function () {
        return Dcent.TYPE;
    };
    Dcent.prototype.id = function () {
        return Dcent.TYPE;
    };
    Dcent.prototype.signMessage = function (message) {
        return this.signPersonalMessage(message);
    };
    Dcent.prototype.signPersonalMessage = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var res, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        return [4, this.awaitLock.acquireAsync()];
                    case 1:
                        _a.sent();
                        return [4, this.dcent.getEthereumSignedMessage(ethUtil.toBuffer(message), this.PATH)];
                    case 2:
                        res = _a.sent();
                        return [2, res.body.parameter.sign];
                    case 3:
                        e_1 = _a.sent();
                        throw e_1;
                    case 4:
                        this.awaitLock.release();
                        return [7];
                    case 5: return [2];
                }
            });
        });
    };
    Dcent.prototype.signTransaction = function (txParams) {
        return __awaiter(this, void 0, void 0, function () {
            var networkID, nonce, gasPrice, gasLimit, res, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, 5, 6]);
                        return [4, this.awaitLock.acquireAsync()];
                    case 1:
                        _a.sent();
                        return [4, this.loadNetworkId()];
                    case 2:
                        networkID = _a.sent();
                        nonce = typeof txParams.nonce === "number" ? new utils_1.BigNumber(txParams.nonce).toString() : txParams.nonce;
                        gasPrice = typeof txParams.gasPrice === "number" ? new utils_1.BigNumber(txParams.gasPrice).toString() : txParams.gasPrice;
                        gasLimit = typeof txParams.gasLimit === "number" ? new utils_1.BigNumber(txParams.gasLimit).toString() : txParams.gasLimit;
                        return [4, this.dcent.getEthereumSignedTransaction(this.dcent.coinType.ETHEREUM, nonce, gasPrice, gasLimit, txParams.to, new utils_1.BigNumber(txParams.value).toString(), txParams.data, this.PATH, networkID)];
                    case 3:
                        res = _a.sent();
                        return [2, "0x" + res.body.parameter.signed];
                    case 4:
                        e_2 = _a.sent();
                        throw e_2;
                    case 5:
                        this.awaitLock.release();
                        return [7];
                    case 6: return [2];
                }
            });
        });
    };
    Dcent.prototype.sendTransaction = function (txParams) {
        return __awaiter(this, void 0, void 0, function () {
            var currentAddress, nonce, rawData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!txParams.nonce) return [3, 3];
                        return [4, this.getAddresses()];
                    case 1:
                        currentAddress = _a.sent();
                        return [4, _1.getTransactionCount(currentAddress[0], "pending")];
                    case 2:
                        nonce = _a.sent();
                        txParams.nonce = nonce;
                        _a.label = 3;
                    case 3: return [4, this.signTransaction(txParams)];
                    case 4:
                        rawData = _a.sent();
                        return [2, _1.sendRawTransaction(rawData)];
                }
            });
        });
    };
    Dcent.prototype.getAddresses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, address, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.address) {
                            return [2, [this.address]];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        return [4, this.awaitLock.acquireAsync()];
                    case 2:
                        _a.sent();
                        return [4, this.dcent.getAddress(this.dcent.coinType.ETHEREUM, this.PATH)];
                    case 3:
                        res = _a.sent();
                        address = res.body.parameter.address;
                        this.address = address;
                        if (address) {
                            return [2, [address]];
                        }
                        else {
                            return [2, []];
                        }
                        return [3, 6];
                    case 4:
                        e_3 = _a.sent();
                        throw e_3;
                    case 5:
                        this.awaitLock.release();
                        return [7];
                    case 6: return [2];
                }
            });
        });
    };
    Dcent.prototype.isSupported = function () {
        return !this.address;
    };
    Dcent.prototype.isLocked = function () {
        return !this.address;
    };
    Dcent.prototype.loadNetworkId = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, _1.getNetworkID()];
            });
        });
    };
    Dcent.prototype.sendCustomRequest = function (method, params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, null];
            });
        });
    };
    Dcent.prototype.name = function () {
        return "Dcent";
    };
    Dcent.LABEL = "D'CENT";
    Dcent.TYPE = "DCENT";
    return Dcent;
}(_1.BaseWallet));
exports.default = Dcent;
